const AFTERNOON_TENANTS = ['afternoon', 'kim_jenkins', 'dusk_wealth', 'monument'];
const AFTERNOON_EMAIL_DOMAINS = ['@afternoon.co.uk', '@addjam.com'];

export function hasAfternoonAccess(
  tenantId: string | undefined,
  emailAddress: string | undefined,
): boolean {
  if (!tenantId || !emailAddress) return false;
  const normalisedEmail = emailAddress.toLowerCase();
  return (
    AFTERNOON_TENANTS.includes(tenantId) &&
    AFTERNOON_EMAIL_DOMAINS.some(domain => normalisedEmail.endsWith(domain))
  );
}
